/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.21",
    versionName: "0.7.0-nightly.2026.9.21",
    versionChannel: "nightly",
    buildDate: "2026-09-21T00:16:44.470Z",
    commitHash: "cd2af35c7b0d3ba8a3212c3453eb55db94932a7c",
};
